const type_suffix = {
  image: ["jpg", "png", "bmp", "jpeg"],
  video: ["mp4", "avi", "flv", "mkv", "mpeg"],
  document: ["pdf", "doc", "docx", "xlsx"],
  apk: ["apk"],
  wgt: ["wgt"],
  pdf: ["pdf"],
};
export default {
  transferArrToTree(arr) {
    var nodes = arr.map((item) => ({
      id: item.id,
      label: item.display_name,
      parent_id: item.parent_id,
    }));

    nodes.sort((a, b) => a.parent_id - b.parent_id);
    var midObj = {};
    // 从后向前遍历
    for (var i = nodes.length - 1; i >= 0; i--) {
      var nowPid = nodes[i].parent_id;
      var nowId = nodes[i].id;
      // 建立当前节点的父节点的children 数组
      if (!midObj[nowPid]) midObj[nowPid] = [];
      midObj[nowPid].push(nodes[i]);
      // 将children 放入合适的位置
      if (midObj[nowId]) {
        nodes[i].children = midObj[nowId];
        delete midObj[nowId];
      }
    }
    console.log(midObj[0]);
    return midObj[0];
  },
  formatDate(date, formatTime = false) {
    // date = new Date(Date.parse(date.replace(/-/g, "/"))); //转换成Data();
    if (typeof date == "number") {
      date = new Date(date);
    }
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    if (formatTime) {
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var M = date.getMinutes();
      M = M < 10 ? "0" + M : M;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + M + ":" + s;
    } else {
      return y + "-" + m + "-" + d;

    }
  },
  i18nDate(date) {
    let year = date.slice(0, 4);
    let month = Number(date.slice(5, 7));
    let day = Number(date.slice(8, 10));

    if (process.env.VUE_APP_i18n) {
      return `${month}/${day}/${year}`;
    } else {
      return `${year}年${month}月${day}日`;
    }
  },
  //list数组中某一项的key属性等于value，则返回该项的returnKey属性
  listFilter(list, value, returnKey = "name", key = "id") {
    var item = list.find((item) => {
      if (typeof item[key] == "string" && item[key].split(",").length > 1) {
        return item[key].split(",").some(num => num == value);
      } else {
        return item[key] == value;
      }
    });

    if (returnKey) {
      if (item) {
        return item[returnKey];
      } else {
        return "";
      }
    } else {
      return item;
    }
  },
  type_suffix,
  getTypeBySuffix(fileNameOrSuffix) {
    var splitList = fileNameOrSuffix.split(".");
    const suffix = splitList[splitList.length - 1].toLowerCase();
    console.log("suffix", suffix);

    for (var item in type_suffix) {
      console.log(type_suffix[item]);
      if (type_suffix[item].indexOf(suffix) != -1) {
        // console.log("getTypeBySuffix", item)
        return item;
      }
    }
  }
};
